import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { LocaleService } from '@app/core/i18n';

@Injectable()
export class AlertService {
  private siteId: any;
  private locale: any;

  // EditorPicksIds stores the ids of sections
  // that cannot be retrieved through natural search
  public editorPicksIds = {
    vintage: 1,
    weLove: 3,
    stock: 6
  };

  constructor(private http: HttpClient, private localeService: LocaleService) {
    this.siteId = this.localeService.getRegion();
    this.locale = this.localeService.getLocale().toString();
  }

  getColorList(): Observable<any> {
    const dataUrl = `${environment.apiStaticBaseUrl}${this.siteId}/${this.locale}/colorList.json`;
    return this.http.get(dataUrl);
  }

  getMaterialList(): Observable<any> {
    const dataUrl = `${environment.apiStaticBaseUrl}${this.siteId}/${this.locale}/materialList.json`;
    return this.http.get(dataUrl);
  }

  getSubstateList(): Observable<any> {
    const dataUrl = `${environment.apiStaticBaseUrl}${this.siteId}/${this.locale}/substatesList.json`;
    return this.http.get(dataUrl);
  }

  getPatternList(): Observable<any> {
    const dataUrl = `${environment.apiStaticBaseUrl}${this.siteId}/${this.locale}/patternList.json`;
    return this.http.get(dataUrl);
  }
}
